var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import EuropeanHandicapOutcome from '../outcomes/EuropeanHandicapOutcome';
var EuropeanHandicapSlot = function (props) {
    var outcomes = props.outcomes, gridLocalization = props.gridLocalization, section = props.section, slot = props.slot, match = props.match, expanded = props.expanded;
    var renderOutcomes = [];
    var outcomeProps = {
        gridLocalization: gridLocalization,
        section: section,
        slot: slot,
        match: match,
        expanded: expanded
    };
    var i = 0;
    outcomes.map(function (outcome) {
        var isFirst = i === 0;
        renderOutcomes.push(_jsx(EuropeanHandicapOutcome, __assign({ outcome: outcome }, outcomeProps, { isFirst: isFirst }), outcome.get('id')));
    });
    return renderOutcomes;
};
EuropeanHandicapSlot.propTypes = {
    outcomes: PropTypes.object.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    slot: PropTypes.object.isRequired,
    slotName: PropTypes.string,
    match: PropTypes.object.isRequired,
    filteredRates: PropTypes.object.isRequired,
    section: PropTypes.string.isRequired,
    expanded: PropTypes.bool.isRequired
};
export default EuropeanHandicapSlot;



// WEBPACK FOOTER //
// ./src/components/grid/event/slots/EuropeanHandicapSlot.jsx